// Add this at the very top of your file, before any other code
console.log('Script loaded');  // This will help verify the script is loading

// Method 1: pageshow event
window.addEventListener('pageshow', function (event) {
  const selectedBoxVariant = document.querySelector('.purchase-flow-step_2__box-variants-selector__input:checked');
  if (selectedBoxVariant) {
    console.log('pageshow BoxVariants clicked');
    selectedBoxVariant.click();
    selectedBoxVariant.dispatchEvent(new Event('change', { bubbles: true }));
  }

});

var allVariants = [];
var flowOBJ = { extras: [] };

var byobOBJ = { products: [] };
// Track the step change with Klaviyo
var _learnq = window._learnq || [];

function getQueryParams(key) {
  const urlParams = new URLSearchParams(window.location.search);
  const queryParams = {};
  urlParams.forEach((value, key) => {
    queryParams[key] = value;
  });
  return queryParams[key];
}
console.log('recharge', recharge);

async function getBundleId(bundle) {
  try {
    console.log('bundle', bundle);
    const rb_id = await recharge.bundle.getBundleId(bundle);
    console.log('rb_id', rb_id);
    flowOBJ.rbId = rb_id;
    
    // Instead of calling addToCart directly, dispatch a custom event
    const event = new CustomEvent('bundleIdReceived');
    document.dispatchEvent(event);
  } catch (error) {
    console.error('Error fetching bundle ID:', error);
  }
}


async function BundleSettings() {
  try {
    // Initialize ReCharge first - this is required!
    recharge.init({
      storeIdentifier: '504ac4.myshopify.com',
      appName: 'appName',
      appVersion: '1.0.0'
    });
    const bundleProductID = document.querySelector('.byob-step--1').getAttribute('data-box-product-id');
    if (!bundleProductID) {
      console.log('No bundle product ID found');
      return;
    }
    const bundleSettings = await recharge.cdn.getCDNBundleSettings(bundleProductID);
    byobOBJ.bundleSettings = bundleSettings;
    console.log('bundleSettings', bundleSettings);
  } catch (error) {
    console.error('Error fetching bundle settings:', error);
  }
}

document.addEventListener('DOMContentLoaded', async function () {
  console.log('DOMContentLoaded ya tyt');
  await BundleSettings();
});

byobOBJ.status = true;
document.addEventListener('DOMContentLoaded', function () {
  // console.log('DOMContentLoaded');
  flowOBJ.box_product_id = parseInt(document.querySelector('.byob-step--1').getAttribute('data-box-product-id'));
  const footerContinueButton = document.querySelector('#page-purchase-flow__footer-button--continue');
  const closePopupButton = document.getElementById('close-extra-products-popup');
  const popup = document.getElementById('extra-products-popup');
  const popupShow = popup ? popup.getAttribute('data-show') : false;
  const checkoutButton = document.getElementById('extra-products-popup__checkout-button');

  if (closePopupButton) {
    closePopupButton.addEventListener('click', function () {
      popup.style.display = 'none';
      document.body.classList.add('popup-open');
    });
  }


  if (checkoutButton) {
    checkoutButton.addEventListener('click', function () {
      checkoutButton.disabled = true;
      checkoutButton.textContent = 'Checking out...';
      flowOBJ.extras = [];
      const activeExtraProducts = document.querySelectorAll('.byob-step--4 .purchase-flow__product-card.active');
      if (activeExtraProducts.length > 0) {
        activeExtraProducts.forEach(product => {
          const productId = product.querySelector('[data-product-id]').getAttribute('data-variant-id');
          const quantity = product.querySelector('.purchase-flow-step__quantity-selector input').value;
          flowOBJ.extras.push({ product_id: parseInt(productId), quantity: parseInt(quantity) });
        });
      }
      // addToCart();
      addToBundle();
    });
  }


  // Close popup when clicking outside of it
  window.addEventListener('click', function (event) {
    if (event.target === popup) {
      popup.style.display = 'none';
      document.body.classList.remove('popup-open');
    }
  });

  footerContinueButton.addEventListener('click', function () {
    addBYOBtoArray();
    if (popupShow === 'true') {
      popup.style.display = 'block';
      document.body.classList.add('popup-open');
      const extrasAddOrderButton = document.querySelectorAll('.byob-step--4 [data-add-to-order]');
      if (extrasAddOrderButton.length > 0) {
        extrasAddOrderButton.forEach(button => {
          button.addEventListener('click', function () {
            checkoutButton.textContent = 'Checkout →';
          });
        });
      }
    } else {
      footerContinueButton.disabled = true;
      footerContinueButton.textContent = 'Checking out...';
      // addToCart();
      addToBundle();
    }
  });

  const BoxVariants = document.querySelectorAll('.purchase-flow-step_2__box-variants-selector__input');

  BoxVariants.forEach(variant => {
    variant.addEventListener('change', function () {
      const variantJson = JSON.parse(this.getAttribute('data-json'));
      const price = this.getAttribute('data-price');
      const image = this.getAttribute('data-image');
      const compareAtPrice = parseFloat(price.replace('$', '')) < parseFloat(variantJson.price / 100) ? "$" + (variantJson.price / 100) : "$0";
      // console.log('variantJson', variantJson);
      var item = {
        "ProductName": variantJson.name,
        "ProductID": parseInt(variantJson.id),
        "SKU": variantJson.sku,
        "Categories": [],
        "ImageURL": variantJson.featured_image ? variantJson.featured_image.src : image,
        "URL": location.href,
        "Brand": "AppyHour",
        "Price": price,
        "CompareAtPrice": compareAtPrice
      };
      _learnq.push(["track", "Viewed Product", item]);
      // console.log('item', item);

      const variantId = parseInt(this.value);
      flowOBJ.box_variant_id = variantId;
      const boxSize = parseInt(this.getAttribute('data-box-size'));
      flowOBJ.boxSize = boxSize;
      // updatePlanInfo(price, variantId);
      updateFrequencyInfo(variantId);
      byobQuantityChange(boxSize);
      if (document.querySelector('.preselected-products-toggle') && document.querySelector('.preselected-products-toggle').checked) {
        updatePreselectedProductsToggle(variantId, boxSize);
      }
      // console.log('step2BoxVariants Chage');

      // userSelectedBuildYourOwnBox(); // Call this function to set up or remove BYOB listeners
    });
  });

  function updateFrequencyInfo(variantId) {
    const variant_info = allVariants.find(v => v.id === variantId);
    if (!variant_info) { return; }
    const frequencySelector = document.querySelector('.frequency-selector');
    const frequencySelectorInputs = frequencySelector.querySelectorAll('input[type="radio"]');
    const activeFrequencySelectorInput = frequencySelector.querySelector('input[type="radio"]:checked');
    // console.log('frequencySelectorInputs', frequencySelectorInputs);
    var activeIndex = 0;
    if (activeFrequencySelectorInput) {
      activeIndex = Array.from(frequencySelectorInputs).indexOf(activeFrequencySelectorInput);
      // console.log('activeIndex', activeIndex);
    }
    if (variant_info.selling_plans.length > 0) {
      frequencySelector.innerHTML = '';
      flowOBJ.plan_type = 'payPerBox';

      variant_info.selling_plans.forEach((plan, index) => {
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'frequency';
        input.id = `frequency-${plan.SellingPlanID}`;
        input.value = plan.SellingPlanID;

        input.addEventListener('change', handleFrequencyChange);

        if (index === activeIndex) {
          input.checked = true;
          flowOBJ.selling_plan_id = parseInt(plan.SellingPlanID);
          console.log('flowOBJ', flowOBJ);
        }

        frequencySelector.appendChild(input);

        const label = document.createElement('label');
        label.classList.add('frequency-selector__option');
        label.setAttribute('for', `frequency-${plan.SellingPlanID}`);
        label.textContent = plan.Name.replace('Delivery ', '');
        frequencySelector.appendChild(label);
      });
    }
  }

  function handleFrequencyChange(event) {
    // console.log('handleFrequencyChange', event);
    flowOBJ.selling_plan_id = parseInt(event.target.value);
    // console.log('flowOBJ', flowOBJ);
  }


  function updatePlanInfo(boxPrice, variantId) {
    var flowPlanPrice = boxPrice;
    if (!flowPlanPrice || !variantId) { return; }
    const variant_info = allVariants.find(v => v.id === variantId);
    const prePaidPriceElement = document.querySelector('.selection-pre-paid-price-value');
    const prePaidPriceElementOld = document.querySelector('.selection-pre-paid-price-value-old');
    const prePaidTotalPriceElement = document.querySelector('.selection-pre-paid-total-price-value');
    const payPerBoxPriceElement = document.querySelector('.selection-pay-per-box-price-value');
    const payPerBoxPriceElementOld = document.querySelector('.selection-pay-per-box-price-value-old');
    const variant_price = variant_info.price;
    const price_prepaid = parseFloat(variant_info.prepaid[0].Price.replace('$', '')) / 3;
    const price_per_box = variant_info.payPerBox[0].Price;
    prePaidPriceElement.textContent = flowPlanPrice;

    // console.log('variant_price', variant_price);
    // console.log('price_prepaid', price_prepaid);
    // console.log('price_per_box', price_per_box);

    if (parseFloat(variant_price.replace('$', '')) > (price_prepaid)) {
      prePaidPriceElementOld.textContent = variant_price;
      prePaidPriceElement.textContent = '$' + price_prepaid.toFixed(0);
      prePaidTotalPriceElement.textContent = variant_info.prepaid[0].Price
    } else {
      prePaidPriceElementOld.textContent = '';
      prePaidPriceElement.textContent = variant_price;
      prePaidTotalPriceElement.textContent = '$' + (parseFloat(variant_price.replace('$', '')) * 3).toFixed(0);
    }

    if (parseFloat(variant_price.replace('$', '')) > parseFloat(price_per_box.replace('$', ''))) {
      payPerBoxPriceElementOld.textContent = variant_price;
      payPerBoxPriceElement.textContent = price_per_box;
    } else {
      payPerBoxPriceElementOld.textContent = '';
      payPerBoxPriceElement.textContent = variant_price;
    }

    // 
    // console.log('variantId', variantId);



    const planSelectionBoxes = document.querySelectorAll('.purchase-flow-step_3__plan-selection-box');
    planSelectionBoxes.forEach(box => {
      const planType = box.getAttribute('data-type');
      const planSellingPlanId = box.getAttribute('data-selling-plan-id');
      if (planType === 'prepaid') {
        box.setAttribute('data-selling-plan-id', variant_info.prepaid[0].SellingPlanID);
        flowOBJ.box_variant_id = variantId;
        if (box.classList.contains('active')) {
          flowOBJ.plan_type = 'prepaid';
          flowOBJ.selling_plan_id = parseInt(variant_info.prepaid[0].SellingPlanID);
        }
      } else if (planType === 'payPerBox') {
        box.setAttribute('data-selling-plan-id', variant_info.payPerBox[0].SellingPlanID);
        flowOBJ.box_variant_id = variantId;
        if (box.classList.contains('active')) {
          flowOBJ.plan_type = 'payPerBox';
          flowOBJ.selling_plan_id = parseInt(variant_info.payPerBox[0].SellingPlanID);
        }

        const deliveryFrequencyDropdown = box.querySelector('.purchase-flow-custom-dropdown');
        const customDropdownSelected = deliveryFrequencyDropdown.querySelector('.purchase-flow-custom-dropdown__selected');
        const customDropdownOptions = deliveryFrequencyDropdown.querySelector('.purchase-flow-custom-dropdown__options');

        if (deliveryFrequencyDropdown && variant_info.payPerBox.length > 0) {
          // Clear existing options
          customDropdownOptions.innerHTML = '';

          // Add new options
          variant_info.payPerBox.forEach(plan => {
            const option = document.createElement('div');
            option.classList.add('purchase-flow-custom-dropdown__option');
            option.setAttribute('data-value', plan.SellingPlanID);
            option.textContent = plan.Name;
            customDropdownOptions.appendChild(option);
          });

          const payPerBoxDeliveryFrequencyName = box.querySelector('.pay-per-box-delivery-frequency-name');

          // Remove existing event listeners
          const oldOptionClickHandler = deliveryFrequencyDropdown.optionClickHandler;
          const oldToggleDropdown = deliveryFrequencyDropdown.toggleDropdown;
          const oldCloseDropdown = deliveryFrequencyDropdown.closeDropdown;

          if (oldOptionClickHandler) customDropdownOptions.removeEventListener('click', oldOptionClickHandler);
          if (oldToggleDropdown) customDropdownSelected.removeEventListener('click', oldToggleDropdown);
          if (oldCloseDropdown) document.removeEventListener('click', oldCloseDropdown);

          // Set up new event listeners
          deliveryFrequencyDropdown.optionClickHandler = function (event) {
            if (event.target.classList.contains('purchase-flow-custom-dropdown__option')) {
              const selectedValue = event.target.getAttribute('data-value');
              const selectedText = event.target.textContent;
              const parentBox = event.target.closest('.purchase-flow-step_3__plan-selection-box');
              parentBox.click();
              customDropdownSelected.textContent = selectedText;
              payPerBoxDeliveryFrequencyName.textContent = selectedText;
              flowOBJ.selling_plan_id = parseInt(selectedValue);
              box.setAttribute('data-selling-plan-id', selectedValue);

              // console.log('Selected option:', selectedText);
              // console.log('flowOBJ', flowOBJ);

              deliveryFrequencyDropdown.classList.remove('open');
            }
          };

          deliveryFrequencyDropdown.toggleDropdown = function (event) {
            event.preventDefault();
            event.stopPropagation();
            deliveryFrequencyDropdown.classList.toggle('open');
          };

          deliveryFrequencyDropdown.closeDropdown = function (event) {
            if (!deliveryFrequencyDropdown.contains(event.target)) {
              deliveryFrequencyDropdown.classList.remove('open');
            }
          };

          customDropdownOptions.addEventListener('click', deliveryFrequencyDropdown.optionClickHandler);
          customDropdownSelected.addEventListener('click', deliveryFrequencyDropdown.toggleDropdown);
          document.addEventListener('click', deliveryFrequencyDropdown.closeDropdown);

          // Set initial value
          if (variant_info.payPerBox.length > 0) {
            const initialPlan = variant_info.payPerBox[0];
            customDropdownSelected.textContent = initialPlan.Name;
            payPerBoxDeliveryFrequencyName.textContent = initialPlan.Name;
            flowOBJ.selling_plan_id = parseInt(initialPlan.SellingPlanID);
            box.setAttribute('data-selling-plan-id', initialPlan.SellingPlanID);
          }
        }
      }
    });
    // console.log('flowOBJ', flowOBJ);
  }


  const planSelectionBoxes = document.querySelectorAll('.purchase-flow-step_3__plan-selection-box');

  planSelectionBoxes.forEach(box => {
    box.addEventListener('click', function () {

      planSelectionBoxes.forEach(box => {
        box.classList.remove('active');
      });
      this.classList.add('active');
      const boxType = this.getAttribute('data-type');
      const boxSellingPlanId = parseInt(this.getAttribute('data-selling-plan-id')) ? parseInt(this.getAttribute('data-selling-plan-id')) : parseInt(this.querySelector('.purchase-flow-step_3__plan-selection-box-content-delivery-frequency-dropdown').value);
      if (boxSellingPlanId) {
        flowOBJ.selling_plan_id = boxSellingPlanId;
        flowOBJ.plan_type = boxType;
        // console.log('flowOBJ', flowOBJ);
      }
      const planSelectionType = document.querySelector('.purchase-flow-step_3__plan-selection input[name="plan_type"]');

      planSelectionType.value = boxType;
    });
  });

  // Delivery Date
  const calendarEnabled = document.querySelector('#delivery-date-input-checkbox').getAttribute('data-calendar-enabled') === 'true' ? true : false;
  if (calendarEnabled) {
    const selectedOption = document.querySelector('.purchase-flow-step_3__plan-selection-delivery-dropdown-label');
    // const customDates = document.querySelector('#delivery-date-input-checkbox').getAttribute('data-custom-dates') ? JSON.parse(document.querySelector('#delivery-date-input-checkbox').getAttribute('data-custom-dates')) : [];
    const customDates = document.querySelector('#delivery-date-input-checkbox').getAttribute('data-custom-dates') ? JSON.parse(document.querySelector('#delivery-date-input-checkbox').getAttribute('data-custom-dates')) : [];
    let enableDates = [];
    const today = new Date();
    console.log('customDates', customDates);
    if (customDates && customDates.length > 0) {

      enableDates = customDates
        .filter(dateRange => {
          if (dateRange.shipping_date_expires && dateRange.shipping_date_expires !== '') {
            const cutOffDate = new Date(dateRange.shipping_date_expires);
            const today = new Date();
            // console.log('dateRange.shipping_date_expires', dateRange.shipping_date_expires, today);
            return cutOffDate >= today;
          } else {

            const shippingDate = new Date(dateRange.shipping_date + 'T00:00:00');
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            // console.log('dateRange.shipping_date', dateRange.shipping_date, today);
            return shippingDate >= today;
          }
        })
        .map(dateRange => ({
          from: new Date(dateRange.delivery_start_date + 'T00:00:00'),
          to: new Date(dateRange.delivery_end_date + 'T23:59:59')
        }));
    } else {
      console.log('no custom dates');
      const cutOffDate = new Date(today);
      enableDates = Array.from({ length: 12 }, (_, i) => {
        // Create date in local timezone
        const startDate = new Date(today);
        startDate.setHours(0, 0, 0, 0);
        // console.log('startDate', startDate);

        // If current day is after Monday and time is after 9am, move to next week
        if (cutOffDate.getDay() >= 1 && cutOffDate.getHours() > 8) {
          startDate.setDate(startDate.getDate() + 7);
        }

        // Find next Tuesday
        startDate.setDate(startDate.getDate() + ((2 + 7 - startDate.getDay()) % 7) + (i * 7));
        startDate.setHours(0, 0, 0, 0);
        // console.log('startDate', startDate);

        const endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + 3); // Friday is 2 days after Tuesday

        // Create ISO strings but preserve the local dates

        endDate.setHours(23, 59, 59, 999);

        return {
          from: startDate,
          to: endDate
        };
      });
    }
    console.log('enableDates', enableDates);

    const firstValidRange = enableDates.find(range => range.from != null && range.to != null);
    const defaultDate = firstValidRange ? [
      new Date(firstValidRange.from),
      new Date(firstValidRange.to)
    ] : null;
    console.log('defaultDate', defaultDate);
    const calendar = flatpickr("#delivery-date-input", {
      mode: "range",
      dateFormat: "F j, Y",
      appendTo: document.getElementById('calendar-container'),
      static: true,
      inline: true,
      minDate: today,
      maxDate: enableDates.length > 0 ? new Date(enableDates[enableDates.length - 1].to.getTime() + 24 * 60 * 60 * 1000) : null,
      firstDayOfWeek: 0,
      enable: [
        function (date) {
          // Only allow Wednesday (3), Thursday (4), or Friday (5)
          // if (!customDates || customDates.length === 0) {
          //   console.log('date', date);
          //   if (date.getDay() !== 3 && date.getDay() !== 4 && date.getDay() !== 5) {
          //     return false;
          //   }
          // }

          // Check if the date falls within any of our enabled ranges
          return enableDates.some(range =>
            date >= range.from && date <= range.to
          );
        }
      ],
      defaultDate: defaultDate,
      onChange: function (selectedDates, dateStr, instance) {
        if (selectedDates.length === 1) {
          console.log('selectedDates', selectedDates);
          // Find the matching range for the selected date
          const date = selectedDates[0];
          const matchingRange = enableDates.find(range =>
            date >= range.from && date <= range.to
          );
          console.log('matchingRange', matchingRange);

          if (matchingRange) {
            instance.setDate([matchingRange.from, matchingRange.to], true);
          } else {
            instance.clear();
          }
        } else if (selectedDates.length === 2) {
          const startDate = selectedDates[0];
          const endDate = selectedDates[1];

          // Find matching range that contains both dates
          const matchingRange = enableDates.find(range =>
            startDate >= range.from && endDate <= range.to
          );

          if (!matchingRange) {
            instance.clear();
          } else {
            selectedOption.textContent = formatDateRange(startDate, endDate);
            document.querySelector('.item--first-delivery-value').textContent = selectedOption.textContent;
            flowOBJ.first_delivery_window = selectedOption.textContent;
            const calendarShipDate = new Date(startDate);
            // Find the Monday before the delivery date (which is 3 days before)
            const daysToMonday = ((calendarShipDate.getDay() + 7) - 1) % 7;
            calendarShipDate.setDate(calendarShipDate.getDate() - daysToMonday);
            const calendar_ship = formatYYYYMMDD(calendarShipDate);
            document.querySelector('.item--first-delivery-value').setAttribute('data-ship', calendar_ship);
            flowOBJ._SHIP = calendar_ship;
            document.querySelector('#delivery-date-input-checkbox').checked = false;
          }
        }

        setTimeout(() => {
          const dayElements = calendarContainer.getElementsByClassName('flatpickr-day');
          attachHoverListeners(dayElements);
        }, 0);
      },
      onMonthChange: function (date, instance) {
        setTimeout(() => {
          const dayElements = calendarContainer.getElementsByClassName('flatpickr-day');
          attachHoverListeners(dayElements);
        }, 0);
      },
      onYearChange: function (date, instance) {
        setTimeout(() => {
          const dayElements = calendarContainer.getElementsByClassName('flatpickr-day');
          attachHoverListeners(dayElements);
        }, 0);
      },
      onReady: function (selectedDates, dateStr, instance) {
        console.log('onReady', selectedDates);


        if (selectedDates && selectedDates.length === 2) {
          selectedOption.textContent = formatDateRange(selectedDates[0], selectedDates[1]);
          document.querySelector('.item--first-delivery-value').textContent = selectedOption.textContent;
          flowOBJ.first_delivery_window = selectedOption.textContent;
          const calendarShipDate = new Date(selectedDates[0]);
          // Find the Monday before the delivery date (which is 3 days before)
          const daysToMonday = ((calendarShipDate.getDay() + 7) - 1) % 7;
          calendarShipDate.setDate(calendarShipDate.getDate() - daysToMonday);
          const calendar_ship = formatYYYYMMDD(calendarShipDate);
          document.querySelector('.item--first-delivery-value').setAttribute('data-ship', calendar_ship);
          flowOBJ._SHIP = calendar_ship;
        }
      }
    });

    const calendarContainer = calendar.calendarContainer;
    if (calendarContainer) {
      const dayElements = calendarContainer.getElementsByClassName('flatpickr-day');

      function attachHoverListeners(dayElements) {
        Array.from(dayElements).forEach(dayElem => {
          dayElem.removeEventListener('mouseover', handleDayHover);
          dayElem.addEventListener('mouseover', handleDayHover);
        });
      }

      function handleDayHover(e) {
        if (!e.target.classList.contains('flatpickr-disabled')) {
          const date = new Date(e.target.dateObj);

          // Clear all hover states first
          Array.from(dayElements).forEach(el => {
            el.classList.remove('hover-in-range');
            el.classList.remove('hover-startRange');
            el.classList.remove('hover-endRange');
          });

          // Find the matching date range for the hovered date
          const matchingRange = enableDates.find(range =>
            date >= range.from && date <= range.to
          );

          if (matchingRange) {
            Array.from(dayElements).forEach(el => {
              if (!el.classList.contains('flatpickr-disabled') &&
                !el.classList.contains('selected') &&
                !el.classList.contains('startRange') &&
                !el.classList.contains('endRange') &&
                !el.classList.contains('inRange')) {

                const elementDate = new Date(el.dateObj);

                // Compare dates ignoring time
                const isStartDate = elementDate.toDateString() === matchingRange.from.toDateString();
                const isEndDate = elementDate.toDateString() === new Date(matchingRange.to.getTime() - (23 * 60 * 60 * 1000 + 59 * 60 * 1000 + 59 * 1000)).toDateString();
                const isInRange = elementDate > matchingRange.from && elementDate < matchingRange.to && !isEndDate;

                if (isStartDate) {
                  el.classList.add('hover-startRange');
                } else if (isEndDate) {
                  el.classList.add('hover-endRange');
                } else if (isInRange) {
                  el.classList.add('hover-in-range');
                }
              }
            });
          }
        } else {
          // Clear hover states when hovering disabled dates
          Array.from(dayElements).forEach(el => {
            if (!el.classList.contains('selected') &&
              !el.classList.contains('startRange') &&
              !el.classList.contains('endRange') &&
              !el.classList.contains('inRange')) {
              el.classList.remove('hover-in-range');
              el.classList.remove('hover-startRange');
              el.classList.remove('hover-endRange');
            }
          });
        }
      }
      // Initial attachment of hover listeners
      attachHoverListeners(dayElements);

      // Add mouseleave handler to clear hover states
      calendarContainer.addEventListener('mouseleave', () => {
        Array.from(dayElements).forEach(el => {
          el.classList.remove('hover-in-range');
          el.classList.remove('hover-startRange');
          el.classList.remove('hover-endRange');
        });
      });
    }

  }

  function formatYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  function formatDateRange(startDate, endDate) {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    if (startDate.getMonth() === endDate.getMonth()) {
      // Same month format: "December  4 -  6"
      return `${months[startDate.getMonth()]}  ${startDate.getDate()} -  ${endDate.getDate()}`;
    } else {
      // Different months format: "December  31 - January  2"
      return `${months[startDate.getMonth()]}  ${startDate.getDate()} - ${months[endDate.getMonth()]}  ${endDate.getDate()}`;
    }
  }



  const quantityContainers = document.querySelectorAll('.purchase-flow-step__quantity-selector');

  quantityContainers.forEach(container => {
    const decreaseBtn = container.querySelector('.decrease');
    const increaseBtn = container.querySelector('.increase');
    const input = container.querySelector('input');

    decreaseBtn.addEventListener('click', () => updateQuantity(input, -1));
    increaseBtn.addEventListener('click', () => updateQuantity(input, 1));
    input.addEventListener('change', () => validateInput(input));

  });

  function updateQuantity(input, change) {
    let newValue = parseInt(input.value) + change;
    newValue = Math.max(parseInt(input.min), Math.min(parseInt(input.max), newValue));
    input.value = newValue;
    if (newValue === 0) {
      input.closest('.purchase-flow-step__quantity-selector').style.display = 'none';
      input.closest('.purchase-flow__product-card').classList.remove('active');
      input.closest('.purchase-flow__product-card').querySelector('[data-add-to-order]').style.display = 'block';
    }
  }

  function validateInput(input) {
    let value = parseInt(input.value);
    value = Math.max(parseInt(input.min), Math.min(parseInt(input.max), value));
    input.value = value;
  }

  const addToOrderButtons = document.querySelectorAll('[data-add-to-order]');

  addToOrderButtons.forEach(button => {
    button.addEventListener('click', function () {
      // console.log('addToOrder');
      button.style.display = 'none';
      button.closest('.purchase-flow__product-card').querySelector('.purchase-flow-step__quantity-selector').style.display = 'flex';
      button.closest('.purchase-flow__product-card').classList.add('active');
      button.closest('.purchase-flow__product-card').querySelector('.purchase-flow-step__quantity-selector input').value = 1;
    });
  });

  // document.getElementById('open-calendar-label').addEventListener('click', function() {
  //   const calendarContainer = document.getElementById('calendar-container');
  //   if (calendarContainer.style.maxHeight === '0px') {
  //     calendarContainer.style.maxHeight = calendarContainer.scrollHeight + 'px';
  //     calendar.open();
  //   } else {
  //     calendarContainer.style.maxHeight = '0px';
  //   }
  // });

  // Function to check if the user selected the 3rd product
  function userSelectedBuildYourOwnBox() {
    const box3VariantSelector = document.querySelector('input[name="box3-variant-selector"]:checked');
    // console.log('box3VariantSelector', box3VariantSelector);
    if (document.querySelector('.build-your-own-container') && box3VariantSelector && box3VariantSelector.closest('.purchase-flow-step_2__box').classList.contains('active')) {
      // console.log('userSelectedBuildYourOwnBox');
      document.querySelector('.build-your-own-container').classList.add('active');
      const boxSize = parseInt(box3VariantSelector.getAttribute('data-box-size'));
      byobQuantityChange(boxSize);
      // updatePreselectedProductsToggle(variantId);
      return true;
    } else {
      // console.log('userDidNotSelectBuildYourOwnBox');
      byobOBJ.status = false;
      if (document.querySelector('.build-your-own-container')) {
        document.querySelector('.build-your-own-container').classList.remove('active');
      }
      return false;
    }
  }

  const preselectedProductsToggle = document.querySelector('#preselected-products-toggle');
  if (preselectedProductsToggle) {
    preselectedProductsToggle.addEventListener('change', function () {
      const variantId = flowOBJ.box_variant_id;
      const boxSize = flowOBJ.boxSize;
      if (variantId) {
        updatePreselectedProductsToggle(variantId, boxSize);
      }
    });
  }

  function updatePreselectedProductsToggle(variantId, boxSize) {
    console.log('updatePreselectedProductsToggle', variantId);
    if (!byobOBJ.bundleSettings) {
      return;
    }
    console.log('bundleSettings', byobOBJ.bundleSettings);

    const variant = byobOBJ.bundleSettings.variants.find(variant => variantId === parseInt(variant.external_variant_id));
    // console.log('variant', variant);
    if (!variant && !variant.selection_defaults.length <= 0) {
      return;
    }
    console.log('variants', variant);
    const quantityInputs = document.querySelectorAll('.byob-step--3 .purchase-flow__quantity-selector-input');
    quantityInputs.forEach(input => {
      input.value = 0;
      input.parentElement.style.display = 'none';
      // console.log('input.parentElement', input.parentElement);
      input.parentElement.closest('.purchase-flow__product-card').querySelector('.purchase-flow__product-card__button').style.display = 'block';
      // input.closest('.purchase-flow__quantity-selector').style.display = 'none';
    });
    if (preselectedProductsToggle.checked) {
      const activeProductCards = document.querySelectorAll('.byob-step--3 .purchase-flow__product-card.active');
      activeProductCards.forEach(productCard => {
        productCard.classList.remove('active');
      });
      // console.log('preselectedProductsToggle is checked');
      const preselectedProducts = variant.selection_defaults;
      preselectedProducts.forEach(product => {
        // console.log('product.variants[0].id', product.variants[0].id);
        // console.log('variant_id', product.external_variant_id);
        const productCardButton = document.querySelector(`.purchase-flow__product-card:not(.purchase-flow__product-card--unavailable) [data-variant-id="${parseInt(product.external_variant_id)}"]`);
        if (!productCardButton) {
          console.log('productCardButton not found', product.external_variant_id);
          return;
        }
        const productCard = productCardButton.closest('.purchase-flow__product-card');
        // console.log('productCard', productCard);
        if (productCard) {
          const productQtyInput = productCard.querySelector('.purchase-flow__quantity-selector-input');
          // console.log('productQtyInput before', productQtyInput);
          productCardButton.dispatchEvent(new Event('click'));
          if (productQtyInput) {
            productQtyInput.value = product.quantity;
          }
          
        }
      });
    } else {
      const activeProductCards = document.querySelectorAll('.byob-step--3 .purchase-flow__product-card.active');
      activeProductCards.forEach(productCard => {
        productCard.classList.remove('active');
      });
      // console.log('preselectedProductsToggle is not checked');
    }
    byobQuantityChange(boxSize);
  }

  function byobQuantityChange(boxSize) {
    footerContinueButton.textContent = `Add ${boxSize} more item${boxSize !== 1 ? 's' : ''}`;
    const quantityInputs = document.querySelectorAll('.byob-step--3 .purchase-flow__quantity-selector-input');
    const decreaseButtons = document.querySelectorAll('.byob-step--3 .decrease');
    const increaseButtons = document.querySelectorAll('.byob-step--3 .increase');
    const addToOrderButtons = document.querySelectorAll('.byob-step--3 [data-add-to-order]');
    const productCards = document.querySelectorAll('.byob-step--3 .purchase-flow__product-card');
    const activeTotalQuantity = Array.from(quantityInputs).reduce((sum, input) => sum + parseInt(input.value), 0);

    if (activeTotalQuantity > boxSize) {
      quantityInputs.forEach(input => {
        input.value = 0;
      });
    }




    function updateButtonState() {
      const totalQuantity = Array.from(quantityInputs).reduce((sum, input) => sum + parseInt(input.value), 0);
      if (totalQuantity >= boxSize) {
        footerContinueButton.disabled = false;
        footerContinueButton.textContent = 'Checkout →';

        if (popupShow == 'true') {
          footerContinueButton.textContent = 'Next →';
        }
        footerContinueButton.addEventListener('click', function () {
          addBYOBtoArray();
        });
        addToOrderButtons.forEach(button => {
          button.disabled = true;
        });
        productCards.forEach(card => {
          if (!card.classList.contains('active')) {
            card.classList.add('disabled');
          }
        });
        increaseButtons.forEach(button => {
          button.disabled = true;
        });


      } else {

        increaseButtons.forEach(button => {
          button.disabled = false;
        });
        addToOrderButtons.forEach(button => {
          button.disabled = false;
        });
        productCards.forEach(card => {
          card.classList.remove('disabled');
        });
        footerContinueButton.disabled = true;
        footerContinueButton.textContent = `Add ${boxSize - totalQuantity} more item${boxSize - totalQuantity !== 1 ? 's' : ''} →`;
      }
    }

    addToOrderButtons.forEach(button => {
      button.addEventListener('click', () => {
        // console.log('byob add to order');
        updateButtonState();
      });
    });

    decreaseButtons.forEach(button => {
      button.addEventListener('click', () => {
        // console.log('byob decrease');
        updateButtonState();
      });
    });

    increaseButtons.forEach(button => {
      button.addEventListener('click', () => {
        // console.log('byob increase');
        updateButtonState();
      });
    });

    quantityInputs.forEach(input => {
      input.addEventListener('change', () => {
        // console.log('byob input change');
        updateButtonState();
      });
    });

    // Initial update
    updateButtonState();
  }

  function addBYOBtoArray() {
    byobOBJ.products = [];
    const activeBYOBProducts = document.querySelectorAll('.byob-step--3 .purchase-flow__product-card.active');

    if (activeBYOBProducts.length > 0) {
      byobOBJ.status = true;
      activeBYOBProducts.forEach(product => {
        const productName = product.querySelector('.purchase-flow__product-title').textContent.trim();
        const productID = parseInt(product.querySelector('.purchase-flow__product-card__button').getAttribute('data-product-id'));
        const variantID = parseInt(product.querySelector('.purchase-flow__product-card__button').getAttribute('data-variant-id'));
        const collectionID = parseInt(product.querySelector('.purchase-flow__product-card__button').getAttribute('data-collection-id'));
        const quantity = product.querySelector('.purchase-flow__quantity-selector-input').value;
        byobOBJ.products.push({ product_name: productName, quantity: parseInt(quantity), product_id: productID, variant_id: variantID, collection_id: collectionID });
      });
    }

    // console.log('byobOBJ', byobOBJ);
  }



  // Build your own box Collections Filter
  const byobCollectionsFilterButtons = document.querySelectorAll('.byob-step--3 .purchase-flow__collections-filter-button');
  const byobCollections = document.querySelectorAll('.byob-step--3 .purchase-flow__collection');
  const byobCollectionsFilterDropdown = document.querySelectorAll('.byob-step--3 .purchase-flow__collections-filter-buttons.mobile .purchase-flow-dropdown');

  byobCollectionsFilterDropdown.forEach(dropdown => {
    dropdown.addEventListener('change', () => {
      // console.log('byob collection filter dropdown');
      byobCollections.forEach(collection => {
        collection.classList.add('hidden');
      });
      const dataCollection = dropdown.value;
      // console.log('dataCollection', dataCollection);
      if (dataCollection === 'all') {
        byobCollections.forEach(collection => {
          collection.classList.remove('hidden');
        });
      } else {
        document.querySelector(`.byob-step--3 .purchase-flow__collection[data-collection="${dataCollection}"]`).classList.remove('hidden');
      }
      dropdown.classList.add('active');
    });
  });

  byobCollectionsFilterButtons.forEach(button => {
    button.addEventListener('click', () => {
      // console.log('byob collection filter button');
      byobCollections.forEach(collection => {
        collection.classList.add('hidden');
      });
      byobCollectionsFilterButtons.forEach(button => {
        button.classList.remove('active');
      });
      const dataCollection = button.getAttribute('data-collection');
      if (dataCollection === 'all') {
        byobCollections.forEach(collection => {
          collection.classList.remove('hidden');
        });
      } else {
        document.querySelector(`.byob-step--3 .purchase-flow__collection[data-collection="${dataCollection}"]`).classList.remove('hidden');
      }
      button.classList.add('active');
    });
  });

  // add Extras filter
  const extrasCollectionsFilterButtons = document.querySelectorAll('.byob-step--4 .purchase-flow__collections-filter-button');
  const extrasCollections = document.querySelectorAll('.byob-step--4 .purchase-flow__collection');
  const extrasCollectionsFilterDropdown = document.querySelectorAll('.byob-step--4 .purchase-flow__collections-filter-buttons.mobile .purchase-flow-dropdown');

  extrasCollectionsFilterDropdown.forEach(dropdown => {
    dropdown.addEventListener('change', () => {
      // console.log('extras collection filter dropdown');
      extrasCollections.forEach(collection => {
        collection.classList.add('hidden');
      });
      const dataCollection = dropdown.value;
      // console.log('dataCollection', dataCollection);
      if (dataCollection === 'all') {
        extrasCollections.forEach(collection => {
          collection.classList.remove('hidden');
        });
      } else {
        document.querySelector(`.byob-step--4 .purchase-flow__collection[data-collection="${dataCollection}"]`).classList.remove('hidden');
      }
      dropdown.classList.add('active');
    });
  });

  extrasCollectionsFilterButtons.forEach(button => {
    button.addEventListener('click', () => {
      // console.log('extras collection filter button');
      extrasCollections.forEach(collection => {
        collection.classList.add('hidden');
      });
      extrasCollectionsFilterButtons.forEach(button => {
        button.classList.remove('active');
      });
      const dataCollection = button.getAttribute('data-collection');
      if (dataCollection === 'all') {
        extrasCollections.forEach(collection => {
          collection.classList.remove('hidden');
        });
      } else {
        document.querySelector(`.byob-step--4 .purchase-flow__collection[data-collection="${dataCollection}"]`).classList.remove('hidden');
      }
      button.classList.add('active');
    });
  });

  // Product More Info
  const productMoreInfoButtons = document.querySelectorAll('.purchase-flow__product-card .purchase-flow__product-card-more-info');
  const productDescription = document.querySelectorAll('.purchase-flow__product-card .purchase-flow__product-card__description');
  const productImage = document.querySelectorAll('.purchase-flow__product-card .purchase-flow__product-card__image');
  const productTitle = document.querySelectorAll('.purchase-flow__product-card .purchase-flow__product-title');
  productTitle.forEach(title => {
    title.addEventListener('click', () => {
      title.closest('.purchase-flow__product-card').querySelector('.purchase-flow__product-card-more-info')?.click();
    });
  });
  productImage.forEach(image => {
    image.addEventListener('click', () => {
      image.closest('.purchase-flow__product-card').querySelector('.purchase-flow__product-card-more-info')?.click();
    });
  });
  productDescription.forEach(description => {
    description.addEventListener('click', () => {
      description.closest('.purchase-flow__product-card').querySelector('.purchase-flow__product-card-more-info')?.click();
    });
  });

  productMoreInfoButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.stopPropagation();
      // console.log('product more info');
      const productImage = button.getAttribute('data-image-url');
      const ingredientsMetafields = button.getAttribute('data-ingredients-metafields');
      // console.log('ingredientsMetafields', ingredientsMetafields);
      // console.log('productImage', productImage);
      const productJson = JSON.parse(button.getAttribute('data-product-json'));
      createProductInfoPopup(productJson, productImage, ingredientsMetafields);
    });
  });

  function createProductInfoPopup(product, productImage, ingredientsMetafields) {
    // Create popup container
    // console.log('product', product);
    const popup = document.createElement('div');
    popup.className = 'product-info-popup';

    // Create popup content
    const content = `
      <div class="product-info-popup-content">
        <button class="product-info-popup-close">&times;</button>
        <h2>${product.title}</h2>
        <div class="product-info-popup-columns">
          <div class="product-info-popup-image">
            <img src="${productImage}" alt="${product.title}" >
          </div>
          <div class="product-info-popup-description">
            ${product.description}
            ${ingredientsMetafields}
          </div>
        </div>
      </div>
    `;

    popup.innerHTML = content;

    // Add popup to the body
    document.body.appendChild(popup);
    document.body.classList.add('popup-open');

    // Add event listener to close button
    const closeButton = popup.querySelector('.product-info-popup-close');
    closeButton.addEventListener('click', () => {
      document.body.removeChild(popup);
      document.body.classList.remove('popup-open');
    });

    // Close popup when clicking outside the content
    popup.addEventListener('click', (e) => {
      if (e.target === popup) {
        document.body.removeChild(popup);
      }
    });
  }



  function calculateNextBillingDate(shipDate, frequencyLabel) {
    // if no selling plan, return null
    if (product_1.sellingPlanGroups.length === 0) return null;
    // If gift is selected, return null
    if (document.querySelector('#subscriptionGift') && document.querySelector('#subscriptionGift').checked) return null;

    const today = new Date();
    const date = new Date(shipDate + 'T00:00:00');

    // Check if selected date is at least 7 days from today
    const minimumDate = new Date(today);
    minimumDate.setDate(today.getDate() + 7);

    if (date < minimumDate) {
      return null;
    }


    const matches = frequencyLabel.match(/every (\d+) (month|weeks)/i);
    if (!matches) return shipDate;

    const [_, number, unit] = matches;

    if (unit.toLowerCase() === 'month') {
      date.setMonth(date.getMonth() + parseInt(number));
    } else if (unit.toLowerCase() === 'weeks') {
      date.setDate(date.getDate() + (parseInt(number) * 7));
    }

    return formatYYYYMMDD(date);
  }
  function addToBundle() {
    if (!flowOBJ || !flowOBJ.box_variant_id || !flowOBJ.selling_plan_id) {
      console.error('Invalid flowOBJ:', flowOBJ);
      return;
    }
    // Before getting rbId, create the bundle object
    const bundle = {
      externalVariantId: flowOBJ.box_variant_id,
      externalProductId: flowOBJ.box_product_id,
      selections: byobOBJ.products.map(product => ({
        collectionId: product.collection_id,
        externalProductId: product.product_id,
        externalVariantId: product.variant_id,
        quantity: product.quantity
      }))
    };
    getBundleId(bundle);
  }

  // Add event listener for when bundle ID is received
  document.addEventListener('bundleIdReceived', function() {
    addToCart();
  });

  function addToCart() {
    if (!flowOBJ || !flowOBJ.box_variant_id || !flowOBJ.selling_plan_id) {
      console.error('Invalid flowOBJ:', flowOBJ);
      return;
    }

    // First, clear the cart
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(() => {
        console.log('Cart cleared successfully');

        let items = [];


        // free gift products
        const freeGiftProducts = document.querySelectorAll('input[name="free_gift_products"]');
        if (freeGiftProducts) {
          freeGiftProducts.forEach(product => {
            items.push({ id: parseInt(product.value), quantity: 1 });
          });
        }

        // Add extras as one-time purchases
        if (flowOBJ.extras && flowOBJ.extras.length > 0) {
          flowOBJ.extras.forEach(extra => {
            items.push({
              id: extra.product_id,
              quantity: extra.quantity,
              properties: {
                "Type": "Extra Item",
              }
            });
          });
        }


          const frequencyLabel = document.querySelector('.frequency-selector input[type="radio"]:checked')
            ? document.querySelector('.frequency-selector input[type="radio"]:checked').nextElementSibling.textContent.trim()
            : '';
          const nextBillingDate = flowOBJ.selling_plan_id && flowOBJ._SHIP != '' && flowOBJ._SHIP != null && frequencyLabel != '' ? calculateNextBillingDate(flowOBJ._SHIP, frequencyLabel) : null;
          // Now add the new items
          items.push({
            id: flowOBJ.box_variant_id,
            quantity: 1,
            selling_plan: flowOBJ.selling_plan_id,
            properties: {
              '_rb_id': flowOBJ.rbId,
              'Box Contents': byobOBJ.products.map((product, index, array) => 
                `${product.quantity}x ${product.product_name}${index === array.length - 1 ? '' : ', '}`
              ).join('\n'),
              'First Delivery Window': flowOBJ.first_delivery_window,
              '_SHIP': flowOBJ._SHIP,
              '_NEXT_BILLING_DATE': nextBillingDate
            }
          });


        // console.log('items', items);
        // return;

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: items })
        });
      })
      .then(response => response.json())
      .then(data => {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cartData => {
            // console.log('Raw cart data:', cartData);

            // Format cart data for Klaviyo
            var cart = {
              $value: cartData.total_price / 100, // Total value in dollars
              ItemNames: cartData.items.map(item => item.title),
              Items: cartData.items.map(item => ({
                ProductID: item.product_id,
                SKU: item.sku,
                ProductName: item.title,
                Quantity: item.quantity,
                ItemPrice: item.price / 100,
                RowTotal: (item.price * item.quantity) / 100,
                ProductURL: window.location.origin + item.url,
                ImageURL: item.image,
                ProductCategories: item.product_type ? [item.product_type] : []
              }))
            };

            // console.log('Formatted cart data for Klaviyo:', cart);
            // if (popupShow === 'true') {
            //   checkoutButton.textContent = 'Checkout →';
            //   checkoutButton.removeAttribute('disabled');
            // } else {
            //   footerContinueButton.textContent = 'Continue →';
            //   footerContinueButton.removeAttribute('disabled');
            // }
            _learnq.push(['track', 'Added to Cart', cart]);
            // console.log('Klaviyo push completed');

            // You might want to redirect or update UI here
            
            window.location.href = '/checkout';
          })
          .catch(error => {
            console.error('Error fetching cart data:', error);
          });
      })
      .catch(error => {
        console.error('Error clearing cart or adding items:', error);
      });
  }



  const boxSize = getQueryParams('box-size');
  const boxFrequency = getQueryParams('frequency');
  // console.log('boxSize', boxSize);
  // console.log('boxFrequency', boxFrequency);
  if (boxSize) {
    if (boxSize.includes('Large')) {
      BoxVariants[1] ? BoxVariants[1].click() : null;
      BoxVariants[1] ? BoxVariants[1].dispatchEvent(new Event('change', { bubbles: true })) : null;
    } else {
      // Select the first box by default
      if (BoxVariants.length > 0) {
        // console.log('BoxVariants clicked');
        BoxVariants[0] ? BoxVariants[0].click() : null;
        BoxVariants[0] ? BoxVariants[0].dispatchEvent(new Event('change', { bubbles: true })) : null;
      }
    }
    updatePreselectedProductsToggle(flowOBJ.box_variant_id, flowOBJ.boxSize);
  } else {
    // Select the first box by default
    if (BoxVariants.length > 0) {
      // console.log('BoxVariants clicked');
      BoxVariants[0] ? BoxVariants[0].click() : null;
      BoxVariants[0] ? BoxVariants[0].dispatchEvent(new Event('change', { bubbles: true })) : null;
    }
  }
  if (boxFrequency) {
    const frequencyLabels = document.querySelectorAll('.frequency-selector__option');
    console.log('frequencyLabels', frequencyLabels);
    frequencyLabels.forEach(label => {
      console.log('label', label.textContent.toLowerCase());
      if (label.textContent.toLowerCase().includes(boxFrequency.toLowerCase())) {
        label.click();
        // label.dispatchEvent(new Event('click', { bubbles: true }));
        // label.dispatchEvent(new Event('change', { bubbles: true }));

      }
    });
  }
  // Function to update collection titles dynamically in Step 3
  function updateCollectionTitles(boxSize) {
    const collectionTitles = document.querySelectorAll('.byob-step--3 .purchase-flow__collection-title');
    if (collectionTitles.length > 0) {
      const firstPick = Math.max(boxSize - 4, 4); // Ensure at least "Pick 4"
      const secondPick = 4; // Always "Pick 4"

      // Update collection titles dynamically
      collectionTitles[0].textContent = collectionTitles[0].dataset.originalTitle + ` (Pick ${firstPick})`;
      if (collectionTitles.length > 1) {
        collectionTitles[1].textContent = collectionTitles[1].dataset.originalTitle + ` (Pick ${secondPick})`;
      }
    }
  }

  // Store original collection titles to prevent duplication
  // document.querySelectorAll('.byob-step--3 .purchase-flow__collection-title').forEach(title => {
  //   title.dataset.originalTitle = title.textContent.trim();
  // });

  // // Set default collection titles based on initially selected variant
  // const initialVariant = document.querySelector('.purchase-flow-step_2__box-variants-selector__input:checked');
  // if (initialVariant) {
  //   updateCollectionTitles(parseInt(initialVariant.getAttribute('data-box-size')));
  // }

  // // Listen for changes in bundle size selection
  // document.querySelectorAll('.purchase-flow-step_2__box-variants-selector__input').forEach(variant => {
  //   variant.addEventListener('change', function () {
  //     updateCollectionTitles(parseInt(this.getAttribute('data-box-size')));
  //   });
  // });



});


